import React, {useEffect, useState} from 'react'

import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import {LoadingComponent} from 'recupero-comunes'
import { Card, Container } from 'react-bootstrap'
import BuscarCasos from './buscar-casos'
import BandejaCasos from './bande-casos'
import { configuracionFormAction32, obtenerComboSituacion, obtenerComboTipoEstado, obtenerComboTipoFecha, obtenerComboTipoGestion, obtenerFechas } from '../../store/actions/are-busqueda-casos-action'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'

const AreaBusquedaCasos = () => {
    const [loading, setLoading]=useState(false)
    const [myQueryState, setMyQuery]=useState(null)
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves,comboGestion} = data_encargado
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :30
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    const dispatch = useDispatch()
    
    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosReducer)
    const {cfg_form32} = data_areaBuscar
    useEffect(()=>{
        
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado,idOrgCaso:idOrganizacionCaso}))

    },[dispatch])
    useEffect(() => {
        if(llaves){ 
        setLoading(true)
         let query = Buffer.from(JSON.stringify({
             rutcia: llaves && llaves['idOrgCaso'],
             idform: 32
         })).toString('base64')
         dispatch(configuracionFormAction32(query))
         .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "rutcia": idOrganizacionCaso,
                "parametro": 1
            })).toString('base64')
            dispatch(obtenerFechas(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 207})).toString('base64')
            dispatch(obtenerComboTipoGestion(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 200})).toString('base64')
            dispatch(obtenerComboTipoEstado(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 201})).toString('base64')
            dispatch(obtenerComboSituacion(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 29})).toString('base64')
            dispatch(obtenerComboTipoFecha(query))
         })
          .then(()=>setLoading(false))
        }
     }, [dispatch,llaves])
    
   
    
    
    return (
        <div> 
             <LoadingComponent show={loading}/>
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{
                                         cfg_form32 &&  `${cfg_form32.cfg_form32['consultacasos-filtrobusqueda']}
                                        `}</Card.Header>
                <Card.Body>
                        <BuscarCasos setMyQuery={setMyQuery} />
                        <BandejaCasos myQueryState={myQueryState} />
                  
             </Card.Body>
            </Card>
            </Container> 
        </div>
    )
}

export default AreaBusquedaCasos
